import { forEach } from "lodash";
import store from "../store/store";

const contractPartyStructureTypes = [
    { value: 1, display: 'Contract Administrator > Supplier' },
    { value: 2, display: 'Client > Contract Administrator > Supplier' },
    { value: 3, display: 'Client > Contract Administrator > Supervisor > Supplier' },
    { value: 4, display: 'Contract Administrator > Supervisor > Supplier' },
];
export const getContractPartyStructureTypes = (intl) => {
    contractPartyStructureTypes[0].display = intl.formatMessage({ id: "OPTIONS.PARTY_STRUCTURE.PM_SUPPLIER" });
    contractPartyStructureTypes[1].display = intl.formatMessage({ id: "OPTIONS.PARTY_STRUCTURE.CLIENT_PM_SUPPLIER" });
    contractPartyStructureTypes[2].display = intl.formatMessage({ id: "OPTIONS.PARTY_STRUCTURE.CLIENT_PM_SUPERVISOR_SUPPLIER" });
    contractPartyStructureTypes[3].display = intl.formatMessage({ id: "OPTIONS.PARTY_STRUCTURE.PM_SUPERVISOR_SUPPLIER" });
    return contractPartyStructureTypes;
}
const actionGroupCategories = [
    { value: 1, display: 'Assigned Actions' },
    { value: 2, display: 'Awaiting Reply' },
    { value: 3, display: 'Awaiting Related Communication' },
    { value: 4, display: 'Awaiting Quotation' },
    { value: 5, display: 'Awaiting Quotation Reply' },
    { value: 6, display: 'Awaiting Action' },
];
export const getActionGroupCategories = (intl) => {
    actionGroupCategories[0].display = intl.formatMessage({ id: "OPTIONS.ACTIONS.GRP_1" });
    actionGroupCategories[1].display = intl.formatMessage({ id: "OPTIONS.ACTIONS.GRP_2" });
    actionGroupCategories[2].display = intl.formatMessage({ id: "OPTIONS.ACTIONS.GRP_3" });
    actionGroupCategories[3].display = intl.formatMessage({ id: "OPTIONS.ACTIONS.GRP_4" });
    actionGroupCategories[4].display = intl.formatMessage({ id: "OPTIONS.ACTIONS.GRP_5" });
    actionGroupCategories[5].display = intl.formatMessage({ id: "OPTIONS.ACTIONS.GRP_6" });
    return actionGroupCategories;
}

const migrationProcessStatus = [
    { value: 1, display: 'Pending' },
    { value: 2, display: 'Processing' },
    { value: 3, display: 'Ended - Success' },
    { value: 4, display: 'Ended - Fail' },
];
export const getMigrationProcessStatus = (intl) => {
    migrationProcessStatus[0].display = intl.formatMessage({ id: "OPTIONS.MIGRATION.PENDING" });
    migrationProcessStatus[1].display = intl.formatMessage({ id: "OPTIONS.MIGRATION.PROCESSING" });
    migrationProcessStatus[2].display = intl.formatMessage({ id: "OPTIONS.MIGRATION.ENDED_SUCCESS" });
    migrationProcessStatus[3].display = intl.formatMessage({ id: "OPTIONS.MIGRATION.ENDED_FAIL" });
    return migrationProcessStatus;
}
export const actionCodes = {
    CREATE: "CREATE",
    SAVE_DRAFT: "SAVE_DRAFT",
    COMMUNICATE: "COMMUNICATE",
    REPLY_DRAFT: "REPLY_DRAFT",
    REPLY_SEND: "REPLY_SEND",
    DELETE_DRAFT: "DELETE_DRAFT",
    ACTION_UPDATE: "ACTION_UPDATE",
    ACTION_CLOSE: "ACTION_CLOSE",
    QUOTE_CREATE: "QUOTE_CREATE",
    QUOTE_SAVE_DRAFT: "QUOTE_SAVE_DRAFT",
    QUOTE_COMMUNICATE: "QUOTE_COMMUNICATE",
    QUOTE_REPLY_DRAFT: "QUOTE_REPLY_DRAFT",
    QUOTE_REPLY_SEND: "QUOTE_REPLY_SEND",
};
export const contractUserPartyOptions = [
    { id: 1, key: "SUPPLIER", display: "Supplier" },
    { id: 2, key: "PM", display: "Project Manager" },
    { id: 3, key: "SUPERVISOR", display: "Supervisor" },
    { id: 4, key: "CLIENT", display: "Client" },
];
export const contractUserPartyOptionMapID = contractUserPartyOptions.reduce((obj, partyOption) => ({ ...obj, [partyOption.id]: partyOption.key }), {});
export const userFilterCategories = {
    ACCESS: "ACCESS",
    MAIN_NOTICE: "MAIN_NOTICE",
    REPLY_NOTICE: "REPLY_NOTICE",
    ACTION_TAB: "ACTION_TAB",
    QUOTATION: "QUOTATION",
    QUOTE_REPLY: "QUOTE_REPLY",
    NOTIFY: "NOTIFY",
    RESOLVE_ACTION_TAB: "RESOLVE_ACTION_TAB"
};

export const customFieldsWfSubTypes = {
    COMMUNICATION: "COMMUNICATION",
    REPLY: "REPLY",
    QUOTE: "QUOTE",
    QUOTE_REPLY: "QUOTE_REPLY",
    RFQQUOTE: "RFQQUOTE",
    RFQQUOTE_REPLY: "RFQQUOTE_REPLY",
    EWREDUCTION: "EWREDUCTION",
    ITQQUOTE: "ITQQUOTE",
    ITQQUOTE_REPLY: "ITQQUOTE_REPLY"
};

export const contractAdminTypes = [
    { key: 1, value: 'Project Manager' },
    { key: 2, value: 'Service Manager' },
];

//ISO 4217 - Currency Code Maintenance: Get the Correct Currency Code
//https://www.six-group.com/en/products-services/financial-information/data-standards.html
export const currencyCodes = [
    { code: 'GBP', name: 'GBP - Pound Sterling' },
    { code: 'EUR', name: 'EUR - Euro' },
    { code: 'USD', name: 'USD - US Dollar' },
    { code: 'AFN', name: 'AFN - Afghani' },
    { code: 'ALL', name: 'ALL - Lek' },
    { code: 'DZD', name: 'DZD - Algerian Dinar' },
    { code: 'AOA', name: 'AOA - Kwanza' },
    { code: 'XCD', name: 'XCD - East Caribbean Dollar' },
    { code: 'ARS', name: 'ARS - Argentine Peso' },
    { code: 'AMD', name: 'AMD - Armenian Dram' },
    { code: 'AWG', name: 'AWG - Aruban Florin' },
    { code: 'AUD', name: 'AUD - Australian Dollar' },
    { code: 'AZN', name: 'AZN - Azerbaijan Manat' },
    { code: 'BSD', name: 'BSD - Bahamian Dollar' },
    { code: 'BHD', name: 'BHD - Bahraini Dinar' },
    { code: 'BDT', name: 'BDT - Taka' },
    { code: 'BBD', name: 'BBD - Barbados Dollar' },
    { code: 'BYN', name: 'BYN - Belarusian Ruble' },
    { code: 'BZD', name: 'BZD - Belize Dollar' },
    { code: 'XOF', name: 'XOF - CFA Franc BCEAO' },
    { code: 'BMD', name: 'BMD - Bermudian Dollar' },
    { code: 'INR', name: 'INR - Indian Rupee' },
    { code: 'BTN', name: 'BTN - Ngultrum' },
    { code: 'BOB', name: 'BOB - Boliviano' },
    { code: 'BOV', name: 'BOV - Mvdol' },
    { code: 'BAM', name: 'BAM - Convertible Mark' },
    { code: 'BWP', name: 'BWP - Pula' },
    { code: 'NOK', name: 'NOK - Norwegian Krone' },
    { code: 'BRL', name: 'BRL - Brazilian Real' },
    { code: 'BND', name: 'BND - Brunei Dollar' },
    { code: 'BGN', name: 'BGN - Bulgarian Lev' },
    { code: 'BIF', name: 'BIF - Burundi Franc' },
    { code: 'CVE', name: 'CVE - Cabo Verde Escudo' },
    { code: 'KHR', name: 'KHR - Riel' },
    { code: 'XAF', name: 'XAF - CFA Franc BEAC' },
    { code: 'CAD', name: 'CAD - Canadian Dollar' },
    { code: 'KYD', name: 'KYD - Cayman Islands Dollar' },
    { code: 'CLP', name: 'CLP - Chilean Peso' },
    { code: 'CLF', name: 'CLF - Unidad de Fomento' },
    { code: 'CNY', name: 'CNY - Yuan Renminbi' },
    { code: 'COP', name: 'COP - Colombian Peso' },
    { code: 'COU', name: 'COU - Unidad de Valor Real' },
    { code: 'KMF', name: 'KMF - Comorian Franc ' },
    { code: 'CDF', name: 'CDF - Congolese Franc' },
    { code: 'NZD', name: 'NZD - New Zealand Dollar' },
    { code: 'CRC', name: 'CRC - Costa Rican Colon' },
    { code: 'CUP', name: 'CUP - Cuban Peso' },
    { code: 'CUC', name: 'CUC - Peso Convertible' },
    { code: 'ANG', name: 'ANG - Netherlands Antillean Guilder' },
    { code: 'CZK', name: 'CZK - Czech Koruna' },
    { code: 'DKK', name: 'DKK - Danish Krone' },
    { code: 'DJF', name: 'DJF - Djibouti Franc' },
    { code: 'DOP', name: 'DOP - Dominican Peso' },
    { code: 'EGP', name: 'EGP - Egyptian Pound' },
    { code: 'SVC', name: 'SVC - El Salvador Colon' },
    { code: 'ERN', name: 'ERN - Nakfa' },
    { code: 'SZL', name: 'SZL - Lilangeni' },
    { code: 'ETB', name: 'ETB - Ethiopian Birr' },
    { code: 'FKP', name: 'FKP - Falkland Islands Pound' },
    { code: 'FJD', name: 'FJD - Fiji Dollar' },
    { code: 'XPF', name: 'XPF - CFP Franc' },
    { code: 'GMD', name: 'GMD - Dalasi' },
    { code: 'GEL', name: 'GEL - Lari' },
    { code: 'GHS', name: 'GHS - Ghana Cedi' },
    { code: 'GIP', name: 'GIP - Gibraltar Pound' },
    { code: 'GTQ', name: 'GTQ - Quetzal' },
    { code: 'GNF', name: 'GNF - Guinean Franc' },
    { code: 'GYD', name: 'GYD - Guyana Dollar' },
    { code: 'HTG', name: 'HTG - Gourde' },
    { code: 'HNL', name: 'HNL - Lempira' },
    { code: 'HKD', name: 'HKD - Hong Kong Dollar' },
    { code: 'HUF', name: 'HUF - Forint' },
    { code: 'ISK', name: 'ISK - Iceland Krona' },
    { code: 'IDR', name: 'IDR - Rupiah' },
    { code: 'XDR', name: 'XDR - SDR (Special Drawing Right)' },
    { code: 'IRR', name: 'IRR - Iranian Rial' },
    { code: 'IQD', name: 'IQD - Iraqi Dinar' },
    { code: 'ILS', name: 'ILS - New Israeli Sheqel' },
    { code: 'JMD', name: 'JMD - Jamaican Dollar' },
    { code: 'JPY', name: 'JPY - Yen' },
    { code: 'JOD', name: 'JOD - Jordanian Dinar' },
    { code: 'KZT', name: 'KZT - Tenge' },
    { code: 'KES', name: 'KES - Kenyan Shilling' },
    { code: 'KPW', name: 'KPW - North Korean Won' },
    { code: 'KRW', name: 'KRW - Won' },
    { code: 'KWD', name: 'KWD - Kuwaiti Dinar' },
    { code: 'KGS', name: 'KGS - Som' },
    { code: 'LAK', name: 'LAK - Lao Kip' },
    { code: 'LBP', name: 'LBP - Lebanese Pound' },
    { code: 'LSL', name: 'LSL - Loti' },
    { code: 'ZAR', name: 'ZAR - Rand' },
    { code: 'LRD', name: 'LRD - Liberian Dollar' },
    { code: 'LYD', name: 'LYD - Libyan Dinar' },
    { code: 'CHF', name: 'CHF - Swiss Franc' },
    { code: 'MOP', name: 'MOP - Pataca' },
    { code: 'MKD', name: 'MKD - Denar' },
    { code: 'MGA', name: 'MGA - Malagasy Ariary' },
    { code: 'MWK', name: 'MWK - Malawi Kwacha' },
    { code: 'MYR', name: 'MYR - Malaysian Ringgit' },
    { code: 'MVR', name: 'MVR - Rufiyaa' },
    { code: 'MRU', name: 'MRU - Ouguiya' },
    { code: 'MUR', name: 'MUR - Mauritius Rupee' },
    { code: 'XUA', name: 'XUA - ADB Unit of Account' },
    { code: 'MXN', name: 'MXN - Mexican Peso' },
    { code: 'MXV', name: 'MXV - Mexican Unidad de Inversion (UDI)' },
    { code: 'MDL', name: 'MDL - Moldovan Leu' },
    { code: 'MNT', name: 'MNT - Tugrik' },
    { code: 'MAD', name: 'MAD - Moroccan Dirham' },
    { code: 'MZN', name: 'MZN - Mozambique Metical' },
    { code: 'MMK', name: 'MMK - Kyat' },
    { code: 'NAD', name: 'NAD - Namibia Dollar' },
    { code: 'NPR', name: 'NPR - Nepalese Rupee' },
    { code: 'NIO', name: 'NIO - Cordoba Oro' },
    { code: 'NGN', name: 'NGN - Naira' },
    { code: 'OMR', name: 'OMR - Rial Omani' },
    { code: 'PKR', name: 'PKR - Pakistan Rupee' },
    { code: 'PAB', name: 'PAB - Balboa' },
    { code: 'PGK', name: 'PGK - Kina' },
    { code: 'PYG', name: 'PYG - Guarani' },
    { code: 'PEN', name: 'PEN - Sol' },
    { code: 'PHP', name: 'PHP - Philippine Peso' },
    { code: 'PLN', name: 'PLN - Zloty' },
    { code: 'QAR', name: 'QAR - Qatari Rial' },
    { code: 'RON', name: 'RON - Romanian Leu' },
    { code: 'RUB', name: 'RUB - Russian Ruble' },
    { code: 'RWF', name: 'RWF - Rwanda Franc' },
    { code: 'SHP', name: 'SHP - Saint Helena Pound' },
    { code: 'WST', name: 'WST - Tala' },
    { code: 'STN', name: 'STN - Dobra' },
    { code: 'SAR', name: 'SAR - Saudi Riyal' },
    { code: 'RSD', name: 'RSD - Serbian Dinar' },
    { code: 'SCR', name: 'SCR - Seychelles Rupee' },
    { code: 'SLE', name: 'SLE - Leone' },
    { code: 'SGD', name: 'SGD - Singapore Dollar' },
    { code: 'XSU', name: 'XSU - Sucre' },
    { code: 'SBD', name: 'SBD - Solomon Islands Dollar' },
    { code: 'SOS', name: 'SOS - Somali Shilling' },
    { code: 'SSP', name: 'SSP - South Sudanese Pound' },
    { code: 'LKR', name: 'LKR - Sri Lanka Rupee' },
    { code: 'SDG', name: 'SDG - Sudanese Pound' },
    { code: 'SRD', name: 'SRD - Surinam Dollar' },
    { code: 'SEK', name: 'SEK - Swedish Krona' },
    { code: 'CHE', name: 'CHE - WIR Euro' },
    { code: 'CHW', name: 'CHW - WIR Franc' },
    { code: 'SYP', name: 'SYP - Syrian Pound' },
    { code: 'TWD', name: 'TWD - New Taiwan Dollar' },
    { code: 'TJS', name: 'TJS - Somoni' },
    { code: 'TZS', name: 'TZS - Tanzanian Shilling' },
    { code: 'THB', name: 'THB - Baht' },
    { code: 'TOP', name: 'TOP - Pa\'anga' },
    { code: 'TTD', name: 'TTD - Trinidad and Tobago Dollar' },
    { code: 'TND', name: 'TND - Tunisian Dinar' },
    { code: 'TRY', name: 'TRY - Turkish Lira' },
    { code: 'TMT', name: 'TMT - Turkmenistan New Manat' },
    { code: 'UGX', name: 'UGX - Uganda Shilling' },
    { code: 'UAH', name: 'UAH - Hryvnia' },
    { code: 'AED', name: 'AED - UAE Dirham' },
    { code: 'USN', name: 'USN - US Dollar (Next day)' },
    { code: 'UYU', name: 'UYU - Peso Uruguayo' },
    { code: 'UYI', name: 'UYI - Uruguay Peso en Unidades Indexadas (UI)' },
    { code: 'UYW', name: 'UYW - Unidad Previsional' },
    { code: 'UZS', name: 'UZS - Uzbekistan Sum' },
    { code: 'VUV', name: 'VUV - Vatu' },
    { code: 'VES', name: 'VES - Bolívar Soberano' },
    { code: 'VED', name: 'VED - Bolívar Soberano' },
    { code: 'VND', name: 'VND - Dong' },
    { code: 'YER', name: 'YER - Yemeni Rial' },
    { code: 'ZMW', name: 'ZMW - Zambian Kwacha' },
    { code: 'ZWL', name: 'ZWL - Zimbabwe Dollar' },
    { code: 'XBA', name: 'XBA - Bond Markets Unit European Composite Unit (EURCO)' },
    { code: 'XBB', name: 'XBB - Bond Markets Unit European Monetary Unit (E.M.U.-6)' },
    { code: 'XBC', name: 'XBC - Bond Markets Unit European Unit of Account 9 (E.U.A.-9)' },
    { code: 'XBD', name: 'XBD - Bond Markets Unit European Unit of Account 17 (E.U.A.-17)' },
    { code: 'XXX', name: 'XXX - The codes assigned for transactions where no currency is involved' },
    { code: 'XAU', name: 'XAU - Gold' },
    { code: 'XPD', name: 'XPD - Palladium' },
    { code: 'XPT', name: 'XPT - Platinum' },
    { code: 'XAG', name: 'XAG - Silver' },
];

export function GetCurrencyCodes(intl) {
    currencyCodes.forEach(item => { item.name = intl.formatMessage({ id: `CURRENCY.${item.code}` }) });
    return currencyCodes;
}


const manualActionTypes = [
    { value: 'INVOICE_REQUIRED', display: "[M]Invoice Required" },
    { value: 'PAY_ASSESS', display: "[M]Assessment Date" },
    { value: 'PAY_DUE', display: "[M]Payment Due" },
    { value: 'FINAL_DFP', display: "[M]Final Date for Payment" },
    { value: 'PAY_LESS', display: "[M]Pay Less Notice" },
    { value: 'OTHER', display: "[M]Other" },
];

export const GetManualActionTypes = (intl) => {
    manualActionTypes[0].display = intl.formatMessage({ id: "OPTIONS.MANUAL_ACTION_TYPES.INVOICE_REQUIRED" });
    manualActionTypes[1].display = intl.formatMessage({ id: "OPTIONS.MANUAL_ACTION_TYPES.PAY_ASSESS" });
    manualActionTypes[2].display = intl.formatMessage({ id: "OPTIONS.MANUAL_ACTION_TYPES.PAY_DUE" });
    manualActionTypes[3].display = intl.formatMessage({ id: "OPTIONS.MANUAL_ACTION_TYPES.FINAL_DFP" });
    manualActionTypes[4].display = intl.formatMessage({ id: "OPTIONS.MANUAL_ACTION_TYPES.PAY_LESS" });
    manualActionTypes[5].display = intl.formatMessage({ id: "OPTIONS.MANUAL_ACTION_TYPES.OTHER" });
    return manualActionTypes;
}



export const contractPartyTypes = [
    'Client',
    'PM',
    'Contractor',
    'Supervisor',
];

const contractTypesBase = [
    "FIDIC Blue-Green Book [aka Turquoise Book] (Dredgers Contract) 1st Edition 1999",
    "FIDIC Blue-Green Book [aka Turquoise Book] (Dredging and Reclamation) 2nd Edition 2016",
    "FIDIC Blue-Green Book [aka Turquoise Book] (Dredging and Reclamation) 2nd Edition 2016 Erratum February 2019",
    "FIDIC Emerald Book (Underground Works) 1st Edition 2019",
    "FIDIC Emerald Book (Underground Works) 1st Edition 2019 Reprinted with amendments November 2023",
    "FIDIC Gold Book (Design Build and Operate) 1st Ed 2008",
    "FIDIC Green Book",
    "FIDIC Green Book (Short Form) 1st Edition 1999",
    "FIDIC Green Book (Short Form) 2nd Edition 2021",
    "FIDIC Joint Venture 1st Edition 1992",
    "FIDIC Orange Book (Design-Build and Turnkey) 1st Edition 1995",
    "FIDIC Red Book",
    "FIDIC Red Book (Construction) 1st Edition 1999",
    "FIDIC Red Book (Construction) 2nd Edition 2017",
    "FIDIC Red Book (Construction) 2nd Edition 2017 Reprinted with amendments December 2018",
    "FIDIC Red Book (Construction) 2nd Edition 2017 Reprinted with amendments June 2019",
    "FIDIC Red Book (Construction) 2nd Edition 2017 Reprinted with amendments November 2022",
    "FIDIC Red Book (MDB Harmonised Construction Edition) 1st Edition May 2005",
    "FIDIC Red Book (MDB Harmonised Construction Edition) 2nd Edition March 2006",
    "FIDIC Red Book (MDB Harmonised Construction Edition) 3rd Edition June 2010",
    "FIDIC Silver Book",
    "FIDIC Silver Book (EPC Turnkey Projects) 1st Edition 1999",
    "FIDIC Silver Book (EPC Turnkey Projects) 2nd Edition 2017",
    "FIDIC Silver Book (EPC Turnkey Projects) 2nd Edition 2017 Reprinted with amendments December 2018",
    "FIDIC Silver Book (EPC Turnkey Projects) 2nd Edition 2017 Reprinted with amendments June 2019",
    "FIDIC Silver Book (EPC Turnkey Projects) 2nd Edition 2017 Reprinted with amendments November 2022",
    "FIDIC Sub-consultancy 1st Edition 1992",
    "FIDIC Sub-consultancy 2nd Edition 2017",
    "FIDIC Sub-consultancy 2nd Edition 2017 Errata February 2019",
    "FIDIC Subcontract Construction (1999 Red Book) Subcontract 1st Edition 2011",
    "FIDIC Subcontract Plant and Design (1999 Yellow Book) 1st Edition 2019",
    "FIDIC White Book (Client/Consultant) 1st Edition 1999",
    "FIDIC White Book (Client/Consultant) 2nd Edition 2001",
    "FIDIC White Book (Client/Consultant) 3rd Edition 2005",
    "FIDIC White Book (Client/Consultant) 4th Edition 2006",
    "FIDIC White Book (Client/Consultant) 5th Edition 2017",
    "FIDIC White Book (Client/Consultant) 5th Edition 2017 Errata February 2019",
    "FIDIC Yellow Book",
    "FIDIC Yellow Book (Plant and Design-Build) 1st Edition 1999",
    "FIDIC Yellow Book (Plant and Design-Build) 2nd Edition 2017",
    "FIDIC Yellow Book (Plant and Design-Build) 2nd Edition 2017 Reprinted with amendments December 2018",
    "FIDIC Yellow Book (Plant and Design-Build) 2nd Edition 2017 Reprinted with amendments June 2019",
    "FIDIC Yellow Book (Plant and Design-Build) 2nd Edition 2017 Reprinted with amendments November 2022",
    "JCT 2016 DBSub",
    "JCT 2016 SBCSub",
    "JCT 2016 SBCSubD",
    "JCT 2016 ShortSub",
    "JCT DB 2016",
    "JCT DB16",
    "JCT ICD 2016",
    "JCT MC",
    "JCT MC 2016",
    "JCT SBC 2016",
    "NEC3 ECC Option A",
    "NEC3 ECC Option B",
    "NEC3 ECC Option C",
    "NEC3 ECC Option D",
    "NEC3 ECC Option E",
    "NEC3 ECC Option F",
    "NEC3 ECS",
    "NEC3 ECS Option A",
    "NEC3 ECS Option B",
    "NEC3 ECS Option C",
    "NEC3 ECS Option D",
    "NEC3 ECS Option E",
    "NEC3 ECS Option F",
    "NEC3 ECSC",
    "NEC3 ECSS",
    "NEC3 FC",
    "NEC3 PSC Option A",
    "NEC3 PSC Option C",
    "NEC3 PSC Option E",
    "NEC3 PSC Option G",
    "NEC3 PSSC",
    "NEC3 SC",
    "NEC3 SSC",
    "NEC3 TSC Option A",
    "NEC3 TSC Option C",
    "NEC3 TSC Option E",
    "NEC3 TSSC",
    "NEC4 ALC",
    "NEC4 DBO",
    "NEC4 DBOC",
    "NEC4 ECC Option A",
    "NEC4 ECC Option B",
    "NEC4 ECC Option C",
    "NEC4 ECC Option D",
    "NEC4 ECC Option E",
    "NEC4 ECC Option F",
    "NEC4 ECS",
    "NEC4 ECS Option A",
    "NEC4 ECS Option B",
    "NEC4 ECS Option C",
    "NEC4 ECS Option D",
    "NEC4 ECS Option E",
    "NEC4 ECS Option F",
    "NEC4 ECSC",
    "NEC4 ECSS",
    "NEC4 FC",
    "NEC4 FMC",
    "NEC4 FMC Option A",
    "NEC4 FMC Option C",
    "NEC4 FMC Option E",
    "NEC4 FMS",
    "NEC4 PSC Option A",
    "NEC4 PSC Option C",
    "NEC4 PSC Option E",
    "NEC4 PSC Option G",
    "NEC4 PSS",
    "NEC4 PSSC",
    "NEC4 SC",
    "NEC4 SSC",
    "NEC4 TSC Option A",
    "NEC4 TSC Option C",
    "NEC4 TSC Option E",
    "NEC4 TSS",
    "NEC4 TSSC"
];
if (process.env.REACT_APP_COST_BREAKDOWN_ENABLED === "true") {
    if (process.env.REACT_APP_PRODUCT_KEY === "EA") {
        contractTypesBase.push(
            "NEC3 ECC Option A (Packaged)",
            "NEC3 ECC Option C (Packaged)",
            "NEC3 ECC Option E (Packaged)",
            "NEC3 PSC Option A (Packaged)",
            "NEC3 PSC Option C (Packaged)",
            "NEC3 PSC Option E (Packaged)"
        );
    }
    else {
        contractTypesBase.push(
            "NEC4 ALC (with CBS)",
            "NEC4 DBO (with CBS)",
            "NEC4 DBOC (with CBS)",
            "NEC4 ECC Option A (with CBS)",
            "NEC4 ECC Option B (with CBS)",
            "NEC4 ECC Option C (with CBS)",
            "NEC4 ECC Option D (with CBS)",
            "NEC4 ECC Option E (with CBS)",
            "NEC4 ECC Option F (with CBS)",
            "NEC4 ECS (with CBS)",
            "NEC4 ECS Option A (with CBS)",
            "NEC4 ECS Option B (with CBS)",
            "NEC4 ECS Option C (with CBS)",
            "NEC4 ECS Option D (with CBS)",
            "NEC4 ECS Option E (with CBS)",
            "NEC4 ECS Option F (with CBS)",
            "NEC4 ECSC (with CBS)",
            "NEC4 ECSS (with CBS)",
            "NEC4 FC (with CBS)",
            "NEC4 FMC (with CBS)",
            "NEC4 FMC Option A (with CBS)",
            "NEC4 FMC Option C (with CBS)",
            "NEC4 FMC Option E (with CBS)",
            "NEC4 FMS (with CBS)",
            "NEC4 PSC Option A (with CBS)",
            "NEC4 PSC Option C (with CBS)",
            "NEC4 PSC Option E (with CBS)",
            "NEC4 PSC Option G (with CBS)",
            "NEC4 PSS (with CBS)",
            "NEC4 PSSC (with CBS)",
            "NEC4 SC (with CBS)",
            "NEC4 SSC (with CBS)",
            "NEC4 TSC Option A (with CBS)",
            "NEC4 TSC Option C (with CBS)",
            "NEC4 TSC Option E (with CBS)",
            "NEC4 TSS (with CBS)",
            "NEC4 TSSC (with CBS)"
        );
    }
}

const contractTypesSorted = [...contractTypesBase].sort((a, b) => a.localeCompare(b));

contractTypesSorted.push("Other");

export const contractTypes = [...contractTypesSorted];

const Base_CBS_ContractTypes_Quotes = [
    "NEC4 ALC (with CBS)",
    "NEC4 DBO (with CBS)",
    "NEC4 DBOC (with CBS)",
    "NEC4 ECC Option A (with CBS)",
    "NEC4 ECC Option B (with CBS)",
    "NEC4 ECC Option C (with CBS)",
    "NEC4 ECC Option D (with CBS)",
    "NEC4 ECC Option E (with CBS)",
    "NEC4 ECC Option F (with CBS)",
    "NEC4 ECS (with CBS)",
    "NEC4 ECS Option A (with CBS)",
    "NEC4 ECS Option B (with CBS)",
    "NEC4 ECS Option C (with CBS)",
    "NEC4 ECS Option D (with CBS)",
    "NEC4 ECS Option E (with CBS)",
    "NEC4 ECS Option F (with CBS)",
    "NEC4 ECSC (with CBS)",
    "NEC4 ECSS (with CBS)",
    "NEC4 FC (with CBS)",
    "NEC4 FMC (with CBS)",
    "NEC4 FMC Option A (with CBS)",
    "NEC4 FMC Option C (with CBS)",
    "NEC4 FMC Option E (with CBS)",
    "NEC4 FMS (with CBS)",
    "NEC4 PSC Option A (with CBS)",
    "NEC4 PSC Option C (with CBS)",
    "NEC4 PSC Option E (with CBS)",
    "NEC4 PSC Option G (with CBS)",
    "NEC4 PSS (with CBS)",
    "NEC4 PSSC (with CBS)",
    "NEC4 SC (with CBS)",
    "NEC4 SSC (with CBS)",
    "NEC4 TSC Option A (with CBS)",
    "NEC4 TSC Option C (with CBS)",
    "NEC4 TSC Option E (with CBS)",
    "NEC4 TSS (with CBS)",
    "NEC4 TSSC (with CBS)"
];
const Base_CBS_ContractTypes_Payment = [
    "NEC4 ALC (with CBS)",
    "NEC4 DBO (with CBS)",
    "NEC4 DBOC (with CBS)",
    "NEC4 ECC Option A (with CBS)",
    "NEC4 ECC Option B (with CBS)",
    "NEC4 ECC Option C (with CBS)",
    "NEC4 ECC Option D (with CBS)",
    "NEC4 ECC Option E (with CBS)",
    "NEC4 ECC Option F (with CBS)",
    "NEC4 ECS (with CBS)",
    "NEC4 ECS Option A (with CBS)",
    "NEC4 ECS Option B (with CBS)",
    "NEC4 ECS Option C (with CBS)",
    "NEC4 ECS Option D (with CBS)",
    "NEC4 ECS Option E (with CBS)",
    "NEC4 ECS Option F (with CBS)",
    "NEC4 ECSC (with CBS)",
    "NEC4 ECSS (with CBS)",
    "NEC4 FC (with CBS)",
    "NEC4 FMC (with CBS)",
    "NEC4 FMC Option A (with CBS)",
    "NEC4 FMC Option C (with CBS)",
    "NEC4 FMC Option E (with CBS)",
    "NEC4 FMS (with CBS)",
    "NEC4 PSC Option A (with CBS)",
    "NEC4 PSC Option C (with CBS)",
    "NEC4 PSC Option E (with CBS)",
    "NEC4 PSC Option G (with CBS)",
    "NEC4 PSS (with CBS)",
    "NEC4 PSSC (with CBS)",
    "NEC4 SC (with CBS)",
    "NEC4 SSC (with CBS)",
    "NEC4 TSC Option A (with CBS)",
    "NEC4 TSC Option C (with CBS)",
    "NEC4 TSC Option E (with CBS)",
    "NEC4 TSS (with CBS)",
    "NEC4 TSSC (with CBS)"
];

if (process.env.REACT_APP_PRODUCT_KEY === "EA" && process.env.REACT_APP_COST_BREAKDOWN_ENABLED === "true") {
    Base_CBS_ContractTypes_Quotes.push(
        'NEC3 ECC Option A',
        'NEC3 ECC Option A (Packaged)',
        'NEC3 ECC Option C',
        'NEC3 ECC Option C (Packaged)',
        'NEC3 ECC Option E',
        'NEC3 ECC Option E (Packaged)',
        'NEC3 PSC Option A (Packaged)',
        'NEC3 PSC Option C (Packaged)',
        'NEC3 PSC Option E (Packaged)'
    );
    Base_CBS_ContractTypes_Payment.push(
        'NEC3 ECC Option A',
        'NEC3 ECC Option A (Packaged)',
        'NEC3 ECC Option C',
        'NEC3 ECC Option C (Packaged)',
        'NEC3 ECC Option E',
        'NEC3 ECC Option E (Packaged)',
        'NEC3 PSC Option A (Packaged)',
        'NEC3 PSC Option C (Packaged)',
        'NEC3 PSC Option E (Packaged)',
        'NEC3 PSC Option A',
        'NEC3 PSC Option C',
        'NEC3 PSC Option E'
    );
}
export const CBS_ContractTypes_Quotes = [...Base_CBS_ContractTypes_Quotes];
export const CBS_ContractTypes_Payment = [...Base_CBS_ContractTypes_Payment];


export const companyTypes = [
    { value: 'Client', display: 'Client' },
    { value: 'Consultant', display: 'Consultant' },
    { value: 'Contractor', display: 'Contractor' },
    { value: 'Other', display: 'Other' },
    { value: 'Subcontractor', display: 'Subcontractor' }
];

export const companyUserTypes = [
    { value: "05314f3f-1beb-49f5-9b92-b847752010bf", label: "Communicate Old" },
    { value: "0a1052f7-bbe8-4628-967e-24331719d134", label: "Project Team Manager" },
    { value: "0e59a6b7-9920-48f6-a247-1a39bdbe71c1", label: "View All" },
    { value: "12de59ac-e311-49be-b4ae-c8443f46d9a5", label: "Super User" },
    { value: "133c037b-5c59-4e33-867d-d02931f904ce", label: "Communicate" },
    { value: "13f88ffb-fac7-4f7c-b235-622bc8275fe6", label: "Programme Analyst" },
    { value: "15ae7e47-bb87-4f6f-8358-e0601a24fa43", label: "Commercial Analyst" },
    { value: "432944be-3f41-4d54-bd9a-7cf212beed16", label: "Read Only" },
    { value: "47e4cf23-556b-4506-8b23-a8ba506f2137", label: "Business Support Officer" },
    { value: "50f73b66-a90f-479e-8c96-90c56f928b08", label: "Supply Chain" },
    { value: "5d2c0192-df22-4d63-8bb8-5ef417856b2b", label: "View All Hub" },
    { value: "61deb3d1-8c2f-48f5-88b4-14815438d7bf", label: "View Own" },
    { value: "62b03732-d497-4fa3-bfac-930525ada16e", label: "Contractors QS" },
    { value: "a3fc4179-6ad8-4dd8-85ad-855de5a64642", label: "Company Administrator" },
    { value: "a8596d59-ee65-4bd4-a858-b725b4930799", label: "Project Managers General User" },
    { value: "657c5fdd-7f11-4895-b666-e2fa8f0efb3c", label: "View Security Groups" }
];

export const projectTypes = [
    'Development',
    'Infrastructure',
    'Mechanical & Electrical',
    'Nuclear',
    'Water & Sewage',
    'Other'
];

export const contractRoleTypes = [
    'Cost Manager',
    'Manager',
    'Read Only',
    'Site Agent',
    'Support'
];



export const countries = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'The   Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Democratic Republic of the Congo', 'Republic of the Congo', 'Costa Rica', 'Ivory Coast', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'The Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Republic of Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'North Korea', 'South Korea', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Republic of Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Federated States of Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Kingdom of the Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'State of Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'];

const contractDateTypes = [
    { value: "CONTRACT_COMPLETION_DATE", display: "Contract Completion Date" },
    { value: "KeyDate", display: "Key Date" },
    { value: "Sectional", display: "Sectional Date" },
    { value: "TaskStartDate", display: "Task Start Date" },
    { value: "TaskCompletionDate", display: "Task Completion Date" },
    { value: "ProjectStartDate", display: "Project Start Date" },
    { value: "ProjectCompletionDate", display: "Project Completion Date" },
    { value: "DefectsDate", display: "Defects Date" },
    { value: "AccessDate", display: "Access Date" },
    { value: "OtherDate", display: "Other Date" },
];
export function GetSecondaryDateTypes(intl) {
    contractDateTypes.forEach(item => { item.display = intl.formatMessage({ id: `OPTIONS.CONTRACT_DATE_TYPE.${item.value}` }) });
    return contractDateTypes;
}


const contractPriceTypes = [
    { value: 'FIDIC_FIXED', display: 'FIDIC: Fixed price' },
    { value: 'FIDIC_REMEASUREMENT', display: 'FIDIC: Remeasurement with bill of quantities' },
    { value: 'JCT_COST', display: 'JCT: Cost reimbursable' },
    { value: 'JCT_FIXED', display: 'JCT: Fixed price' },
    { value: 'JCT_LUMP_SUM_WITH', display: 'JCT: Lump sum with quantities' },
    { value: 'JCT_LUMP_SUM_WITHOUT', display: 'JCT: Lump sum without quantities' },
    { value: 'JCT_MEASURED', display: 'JCT: Measured Term based on a priced schedule of rates' },
    { value: 'JCT_PRICED_RATES', display: 'JCT: Priced with schedule of rates' },
    { value: 'JCT_PRICED_HOURLY', display: 'JCT: Priced with schedule of hourly charges' },
    { value: 'JCT_TENDER', display: 'JCT: Tender price with approximate quantities' },
    { value: 'NEC_OPT_A', display: 'NEC Option A: Priced with activity schedule' },
    { value: 'NEC_OPT_B', display: 'NEC Option B: Priced with bill of quantities' },
    { value: 'NEC_OPT_C', display: 'NEC Option C: Target with activity schedule' },
    { value: 'NEC_OPT_D', display: 'NEC Option D: Target with bill of quantities' },
    { value: 'NEC_OPT_E', display: 'NEC Option E: Cost reimbursable' },
    { value: 'NEC_OPT_F', display: 'NEC Option F: Management' },
    { value: 'NEC_OPT_G', display: 'NEC Option G: Term' },
    { value: 'OTHER_FIXED', display: 'Other: Fixed Price' },
    { value: 'OTHER_REIMBURSABLE', display: 'Other: Reimbursable' },
    { value: 'OTHER_TARGET_COST', display: 'Other: Target cost' }
];


export function GetSecondaryPriceTypes(intl) {
    contractPriceTypes.forEach(item => { item.display = intl.formatMessage({ id: `OPTIONS.CONTRACT_PRICE_TYPE.${item.value}` }) });
    return contractPriceTypes;
}


const contractPriceCategories = [
    { value: "CONTRACT_PRICE", display: "Contract Price" },
    { value: "TASK_ORDER", display: "Task Order" },
    { value: "PROJECT_ORDER", display: "Project Order" },
    // { value: "OTHER_PRICE", display: "Other Price" }
];

export const GetContractPriceCategories = (intl) => {
    contractPriceCategories[0].display = intl.formatMessage({ id: "OPTIONS.CONTRACT_PRICE_CATEGORY.CONTRACT_PRICE" });
    contractPriceCategories[1].display = intl.formatMessage({ id: "OPTIONS.CONTRACT_PRICE_CATEGORY.TASK_ORDER" });
    contractPriceCategories[2].display = intl.formatMessage({ id: "OPTIONS.CONTRACT_PRICE_CATEGORY.PROJECT_ORDER" });
    // contractPriceCategories[3].display = intl.formatMessage({ id: "" });
    return contractPriceCategories;
}



const otherDatePriceChageStates = [
    { value: 0, display: "Unkown" },
    { value: 1, display: "Drafted" },
    { value: 2, display: "Pending Reply" },
    { value: 3, display: "Applied" },
    { value: 4, display: "Rejected" },
    { value: 5, display: "Applied Interim" },
    { value: 6, display: "Reverted Interim" },
    { value: 7, display: "Applied Reverse" }
];

export function GetDatePriceChangeStates(intl) {
    otherDatePriceChageStates.forEach(item => { item.display = intl.formatMessage({ id: `STATUS.CONTRACT_PRICE_DATE_CHANGE.${item.value}` }) });
    return otherDatePriceChageStates;
}

export const contractDocumentTypes = [
    'Contract',
    'Works Information',
    'Scope',
    'BOQ',
    'Drawings',
    'Specifications',
    'Other Documents',
];

export const contractDocumentStatuses = [
    'As-Built',
    'For Approval',
    'For Co-ordination',
    'For Construction',
    'For Tender',
    'For Use',
    'No Objection',
    'Approved',
    'Approved Subject to Comments',
    'Draft',
    'For Information',
    'For Review',
    'Rejected',
    'Revise and Re-Submit',
];

export const statusTypes = [
    'Open',
    'Closed',
];

export const systemAccountStatus = [
    { key: 0, value: 'Active' },
    { key: 1, value: 'Passive' },
];

export const systemStatus = [
    { key: 0, value: 'Active' },
    { key: 1, value: 'Deactivated' },
];

export const recordStatuses = [
    { valueExpr: 1, displayExpr: 'Active' },
    { valueExpr: 2, displayExpr: 'Complete' },
    { valueExpr: 3, displayExpr: 'Archived' },
];

export const contractTagCategories = [
    'Areas',
    'Hubs',
    'Lots',
    'Frameworks',
    'SecurityGroups',
    'ContractOther'
];

export const companyTagCategories = [
    'Frameworks'
];

export const communicationTagCategories = [
    'Portfolio',
    'Programme',
    'Project',
    'Other'
];

export const tagCategories = [
    ...contractTagCategories,
    ...communicationTagCategories
];
export const accessLevel = [
    { key: 1, value: 'Admin only' },
    { key: 2, value: 'All users' },
];

export const languages = [
    { value: "en-GB", display: "English (UK)" },
    { value: "nl-NL", display: "Dutch" },
    // { value: "om", display: "(Afan) Oromo" },
    // { value: "ab", display: "Abkhazian" },
    // { value: "aa", display: "Afar" },
    // { value: "af", display: "Afrikaans" },
    // { value: "sq", display: "Albanian" },
    // { value: "am", display: "Amharic" },
    // { value: "ar", display: "Arabic" },
    // { value: "hy", display: "Armenian" },
    // { value: "as", display: "Assamese" },
    // { value: "ay", display: "Aymara" },
    // { value: "az", display: "Azerbaijani" },
    // { value: "ba", display: "Bashkir" },
    // { value: "eu", display: "Basque" },
    // { value: "bn", display: "Bengali" },
    // { value: "dz", display: "Bhutani" },
    // { value: "bh", display: "Bihari" },
    // { value: "bi", display: "Bislama" },
    // { value: "br", display: "Breton" },
    // { value: "bg", display: "Bulgarian" },
    // { value: "my", display: "Burmese" },
    // { value: "be", display: "Byelorussian" },
    // { value: "km", display: "Cambodian" },
    // { value: "ca", display: "Catalan" },
    { value: "zh", display: "Chinese" },
    // { value: "co", display: "Corsican" },
    // { value: "hr", display: "Croatian" },
    // { value: "cs", display: "Czech" },
    // { value: "da", display: "Danish" },    
    // { value: "eo", display: "Esperanto" },
    // { value: "et", display: "Estonian" },
    // { value: "fo", display: "Faeroese" },
    // { value: "fj", display: "Fiji" },
    // { value: "fi", display: "Finnish" },
    { value: "fr", display: "French" },
    // { value: "fy", display: "Frisian" },
    // { value: "gl", display: "Galician" },
    // { value: "ka", display: "Georgian" },
    { value: "de", display: "German" },
    // { value: "el", display: "Greek" },
    // { value: "kl", display: "Greenlandic" },
    // { value: "gn", display: "Guarani" },
    // { value: "gu", display: "Gujarati" },
    // { value: "ha", display: "Hausa" },
    // { value: "he", display: "Hebrew (former iw)" },
    // { value: "hi", display: "Hindi" },
    // { value: "hu", display: "Hungarian" },
    // { value: "is", display: "Icelandic" },
    // { value: "id", display: "Indonesian (former in)" },
    // { value: "ia", display: "Interlingua" },
    // { value: "ie", display: "Interlingue" },
    // { value: "ik", display: "Inupiak" },
    // { value: "iu", display: "Inuktitut (Eskimo)" },
    // { value: "ga", display: "Irish" },
    { value: "it", display: "Italian" },
    // { value: "ja", display: "Japanese" },
    // { value: "jw", display: "Javanese" },
    // { value: "kn", display: "Kannada" },
    // { value: "ks", display: "Kashmiri" },
    // { value: "kk", display: "Kazakh" },
    // { value: "rw", display: "Kinyarwanda" },
    // { value: "ky", display: "Kirghiz" },
    // { value: "rn", display: "Kirundi" },
    // { value: "ko", display: "Korean" },
    // { value: "ku", display: "Kurdish" },
    // { value: "lo", display: "Laothian" },
    // { value: "la", display: "Latin" },
    // { value: "lv", display: "Latvian, Lettish" },
    // { value: "ln", display: "Lingala" },
    // { value: "lt", display: "Lithuanian" },
    // { value: "mk", display: "Macedonian" },
    // { value: "mg", display: "Malagasy" },
    // { value: "ms", display: "Malay" },
    // { value: "ml", display: "Malayalam" },
    // { value: "mt", display: "Maltese" },
    // { value: "mi", display: "Maori" },
    // { value: "mr", display: "Marathi" },
    // { value: "mo", display: "Moldavian" },
    // { value: "mn", display: "Mongolian" },
    // { value: "na", display: "Nauru" },
    // { value: "ne", display: "Nepali" },
    // { value: "no", display: "Norwegian" },
    // { value: "oc", display: "Occitan" },
    // { value: "or", display: "Oriya" },
    // { value: "ps", display: "Pashto, Pushto" },
    // { value: "fa", display: "Persian" },
    // { value: "pl", display: "Polish" },
    { value: "pt", display: "Portuguese" },
    // { value: "pa", display: "Punjabi" },
    // { value: "qu", display: "Quechua" },
    // { value: "rm", display: "Rhaeto-Romance" },
    // { value: "ro", display: "Romanian" },
    { value: "ru", display: "Russian" },
    // { value: "sm", display: "Samoan" },
    // { value: "sg", display: "Sangro" },
    // { value: "sa", display: "Sanskrit" },
    // { value: "gd", display: "Scots Gaelic" },
    // { value: "sr", display: "Serbian" },
    // { value: "sh", display: "Serbo-Croatian" },
    // { value: "st", display: "Sesotho" },
    // { value: "tn", display: "Setswana" },
    // { value: "sn", display: "Shona" },
    // { value: "sd", display: "Sindhi" },
    // { value: "si", display: "Singhalese" },
    // { value: "ss", display: "Siswati" },
    // { value: "sk", display: "Slovak" },
    // { value: "sl", display: "Slovenian" },
    // { value: "so", display: "Somali" },
    { value: "es", display: "Spanish" },
    // { value: "su", display: "Sudanese" },
    // { value: "sw", display: "Swahili" },
    // { value: "sv", display: "Swedish" },
    // { value: "tl", display: "Tagalog" },
    // { value: "tg", display: "Tajik" },
    // { value: "ta", display: "Tamil" },
    // { value: "tt", display: "Tatar" },
    // { value: "te", display: "Tegulu" },
    // { value: "th", display: "Thai" },
    // { value: "bo", display: "Tibetan" },
    // { value: "ti", display: "Tigrinya" },
    // { value: "to", display: "Tonga" },
    // { value: "ts", display: "Tsonga" },
    // { value: "tr", display: "Turkish" },
    // { value: "tk", display: "Turkmen" },
    // { value: "tw", display: "Twi" },
    // { value: "ug", display: "Uigur" },
    // { value: "uk", display: "Ukrainian" },
    // { value: "ur", display: "Urdu" },
    // { value: "uz", display: "Uzbek" },
    // { value: "vi", display: "Vietnamese" },
    // { value: "vo", display: "Volapuk" },
    // { value: "cy", display: "Welch" },
    // { value: "wo", display: "Wolof" },
    // { value: "xh", display: "Xhosa" },
    // { value: "yi", display: "Yiddish (former ji)" },
    // { value: "yo", display: "Yoruba" },
    // { value: "za", display: "Zhuang" },
    // { value: "zu", display: "Zulu" },
];

export const recordStatusesOptions = [
    { valueExpr: '0', displayExpr: 'No' },
    { valueExpr: '1', displayExpr: 'Yes' },
    { valueExpr: '2', displayExpr: 'All' }
];

export const paymentPeriods = [
    'DAILY',
    'WEEKLY',
    'MONTHLY',
    'ANNUALLY',
    'FIXED'
];

export const calculationPeriods = [
    'DAILY',
    'WEEKLY',
    'MONTHLY',
    'ANNUALLY'
];

export const boolOptions = [
    { value: 0, display: "No" },
    { value: 1, display: "Yes" }
]

const calendarSubscriptionCoverageOptions = [
    { display: 'All Party Actions', value: 'ALL' },
    { display: "Only my party's actions", value: 'MY_PARTY' },
];
export const getCalendarSubscriptionCoverageOptions = (intl) => {
    calendarSubscriptionCoverageOptions[0].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_COVERAGE.ALL" });
    calendarSubscriptionCoverageOptions[1].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_COVERAGE.MY_PARTY" });
    return calendarSubscriptionCoverageOptions;
}

const calendarSubscriptionItemTypes = [
    { display: 'Event Items', value: 'EVENT' },
    { display: "TO-DO Items (Not supported by Outlook)", value: 'TODO' },
];
export const getCalendarSubscriptionItemTypes = (intl) => {
    calendarSubscriptionItemTypes[0].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_ITEM.EVENT" });
    calendarSubscriptionItemTypes[1].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_ITEM.TODO" });
    return calendarSubscriptionItemTypes;
}

const calendarSubscriptionReminders = [
    { display: "Don't remind me", value: 'NONE' },
    { display: "At time of event", value: 'AT_EVENT' },
    { display: "1 day before", value: 'DAY_BEFORE' },
    { display: "1 week before", value: 'WEEK_BEFORE' },
];
export const getCalendarSubscriptionReminders = (intl) => {
    calendarSubscriptionReminders[0].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_REMINDER.NONE" });
    calendarSubscriptionReminders[1].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_REMINDER.AT_EVENT" });
    calendarSubscriptionReminders[2].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_REMINDER.DAY_BEFORE" });
    calendarSubscriptionReminders[3].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_REMINDER.WEEK_BEFORE" });
    return calendarSubscriptionReminders;
}

const calendarSubscriptionReminderTypes = [
    { display: "Display", value: 'DISPLAY' },
    { display: "Email", value: 'EMAIL' },
];
export const getCalendarSubscriptionReminderTypes = (intl) => {
    calendarSubscriptionReminderTypes[0].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_REMINDER_TYPE.DISPLAY" });
    calendarSubscriptionReminderTypes[1].display = intl.formatMessage({ id: "OPTIONS.CALENDAR_REMINDER_TYPE.EMAIL" });
    return calendarSubscriptionReminderTypes;
}

const weekdayOptions = [
    { display: "Monday", value: 'MONDAY' },
    { display: "Tuesday", value: 'TUESDAY' },
    { display: "Wednesday", value: 'WEDNESDAY' },
    { display: "Thursday", value: 'THURSDAY' },
    { display: "Friday", value: 'FRIDAY' },
    { display: "Saturday", value: 'SATURDAY' },
    { display: "Sunday", value: 'SUNDAY' },
];
export const getWeekdayOptions = (intl) => {
    weekdayOptions[0].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.MONDAY" });
    weekdayOptions[1].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.TUESDAY" });
    weekdayOptions[2].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.WEDNESDAY" });
    weekdayOptions[3].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.THURSDAY" });
    weekdayOptions[4].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.FRIDAY" });
    weekdayOptions[5].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.SATURDAY" });
    weekdayOptions[6].display = intl.formatMessage({ id: "OPTIONS.WEEKDAY.SUNDAY" });
    return weekdayOptions;
}

const actionEmailSubscriptionReminderTypesOptions = [
    { display: "Due next 7 days", value: 'NEXT_7_DAYS' },
    { display: "Due next 14 days", value: 'NEXT_14_DAYS' },
    { display: "Due next 21 days", value: 'NEXT_21_DAYS' },
    { display: "Due next 30 days", value: 'NEXT_30_DAYS' },
];
export const getActionEmailSubscriptionReminderTypesOptions = (intl) => {
    actionEmailSubscriptionReminderTypesOptions[0].display = intl.formatMessage({ id: "OPTIONS.EMAIL_REMINDER_TYPE.NEXT_7_DAYS" });
    actionEmailSubscriptionReminderTypesOptions[1].display = intl.formatMessage({ id: "OPTIONS.EMAIL_REMINDER_TYPE.NEXT_14_DAYS" });
    actionEmailSubscriptionReminderTypesOptions[2].display = intl.formatMessage({ id: "OPTIONS.EMAIL_REMINDER_TYPE.NEXT_21_DAYS" });
    actionEmailSubscriptionReminderTypesOptions[3].display = intl.formatMessage({ id: "OPTIONS.EMAIL_REMINDER_TYPE.NEXT_30_DAYS" });
    return actionEmailSubscriptionReminderTypesOptions;
}

export const autoCreateRelationshipMode = [
    'Ask',
    'Always',
    'Never'
];

const genericDraftStatuses = [
    { value: 1, display: 'Pending' },
    { value: 2, display: 'Assigned' },
    { value: 3, display: 'Error' },
];
export const getGenericDraftStatuses = (intl) => {
    genericDraftStatuses[0].display = intl.formatMessage({ id: "OPTIONS.GENERIC_DRAFT_STATUS.PENDING" });
    genericDraftStatuses[1].display = intl.formatMessage({ id: "OPTIONS.GENERIC_DRAFT_STATUS.ASSIGNED" });
    genericDraftStatuses[2].display = intl.formatMessage({ id: "OPTIONS.GENERIC_DRAFT_STATUS.ERROR" });
    return genericDraftStatuses;
}


const genericDraftSources = [
    { value: 1, display: 'Email' },
    { value: 2, display: 'Fastdraft' },
];
export const getGenericDraftSources = (intl) => {
    genericDraftSources[0].display = intl.formatMessage({ id: "OPTIONS.GENERIC_DRAFT_SOURCE.EMAIL" });
    genericDraftSources[1].display = intl.formatMessage({ id: "OPTIONS.GENERIC_DRAFT_SOURCE.FASTDRAFT" });
    return genericDraftSources;
}

export const internalEstimateStatuses = [
    { value: 0, display: 'Superseded' },
    { value: 1, display: 'Active' },
    { value: 2, display: 'Manually Superseded' }
];

export const lifeCycleStages = [
    { value: 1, display: 'Early Warning' },
    { value: 2, display: 'Early Warning' },
    { value: 74, display: 'Early Warning' },
    { value: 4, display: 'Instruction' },
    { value: 56, display: 'Instruction' },
    { value: 71, display: 'Instruction' },
    { value: 5, display: 'CE' },
    { value: 6, display: 'CE' },
    { value: 7, display: 'CE' },
    { value: 37, display: 'CE' },
    { value: 40, display: 'CE' },
    { value: 67, display: 'CE' },
    { value: 75, display: 'CE' },
    { value: 76, display: 'CE' },
    { value: 84, display: 'CE' }
];